import React, { createContext, useContext, useState } from "react";

// Define the context type
interface AppContextType {
  isInDebugMode: boolean;
  toggleDebugMode: () => void;
}

// Create the context with an undefined default value
const AppContext = createContext<AppContextType | undefined>(undefined);

// Provider component
export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isInDebugMode, setIsInDebugMode] = useState<boolean>(false);

  // Toggle function
  const toggleDebugMode = () => setIsInDebugMode((prev) => !prev);

  return (
    <AppContext.Provider value={{ isInDebugMode, toggleDebugMode }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for using the context
export const useApp = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useDebug must be used within a DebugProvider");
  }
  return context;
};
